import {
  ChangeDetectorRef,
  Component,
  ElementRef,
  HostBinding,
  Input,
  OnDestroy,
  OnInit,
  ViewChild,
} from '@angular/core';
import { Product, ProductScope, TranslationService } from '@spartacus/core';
import { CurrentProductService } from '@spartacus/storefront';
import { combineLatest, Observable, of, Subscription, take } from 'rxjs';
import { ProductComparatorFloatingService } from '../product-comparator-floating/core/product-comparator-floating.service';
import { ToasterService } from '../../../../components/toaster/toaster.service';
import { TOASTER_TYPE } from '../../../../components/toaster/toaster.model';
import { PRODUCT_COMPARATOR_TYPE } from '../product-comparator/core/product-comparator.model';
import { isEmpty } from '../../../../core/services/simple-tools';

@Component({
  selector: 'product-compare-check',
  templateUrl: './product-compare-check.component.html',
  styleUrl: './product-compare-check.component.scss',
  standalone: false,
})
export class ProductCompareCheckComponent implements OnInit, OnDestroy {
  STORE = PRODUCT_COMPARATOR_TYPE.FLOATTING;

  @ViewChild('input') input!: ElementRef<HTMLInputElement>;
  @HostBinding('class') hostClass = '';
  @Input() InProduct?: Product;
  @Input() label: string = 'compare.label';

  product$: Observable<Product | null> = this.currentProductService.getProduct([
    ProductScope.DETAILS,
    ProductScope.PRICE,
  ]);

  subscription = new Subscription();
  isChecked = false;

  constructor(
    protected currentProductService: CurrentProductService,
    private floattingService: ProductComparatorFloatingService,
    private toasterService: ToasterService,
    private translationService: TranslationService,
    private cdr: ChangeDetectorRef,
  ) {}

  ngOnInit(): void {
    this.checkInputs();
    this.checkProduct();
  }

  ngOnDestroy(): void {
    this.subscription.unsubscribe();
  }

  checkInputs() {
    if (this.InProduct) {
      this.product$ = of(this.InProduct);
    }
  }

  checkProduct() {
    this.subscription.add(
      combineLatest([this.product$, this.floattingService.store$.asObservable()]).subscribe(
        ([currentProduct, store]) => {
          this.isChecked = store.products?.some(product => product.code === currentProduct?.code);
          this.cdr.detectChanges();
        },
      ),
    );
  }

  handlerClick(product: Product) {
    const input = this.input.nativeElement;
    const products = this.floattingService.store$.getValue().products;
    const firstProducts = products[0];
    input.disabled = true;

    if (input.checked) {
      if (isEmpty(firstProducts) || (firstProducts && firstProducts.topCategory?.code === product.topCategory?.code)) {
        if (products.length < this.floattingService.maxProducts) {
          this.floattingService.addProduct(product);
        } else {
          this.translationService
            .translate('productComparator.error.maxProducts', {
              maxProducts: this.floattingService.maxProducts,
            })
            .pipe(take(1))
            .subscribe(errorMessage => {
              this.toasterService.init({
                type: TOASTER_TYPE.WARNING,
                content: errorMessage,
              });

              input.checked = false;
            });
        }
      } else {
        this.toasterService.init({
          type: TOASTER_TYPE.WARNING,
          content: 'You can compare only products of the same category.',
        });

        input.checked = false;
      }

      input.disabled = false;
    } else {
      this.floattingService.removeProduct(product.code!);
      input.disabled = false;
    }

    this.floattingService.openContainer();
  }
}
